import { useSelector } from 'react-redux';
import { usePrevious } from '@hooks';
import { isEqual } from 'lodash';
import {realTimeModeOnTrendsSelector} from '@store/common/selectors'
import { networkRequestSelector } from '@store/networkRequest/selector';
import { metricFilterRulesSelector } from '@store/trends/base/selectors';

export function useExternalState(enableSSF?: boolean) {
  const realTimeOnTrends = useSelector(realTimeModeOnTrendsSelector);
  const { syncedAutoRefreshState } = useSelector(networkRequestSelector);
  const metricFilter = useSelector(metricFilterRulesSelector);
  const liveAndAutoRefresh = realTimeOnTrends && syncedAutoRefreshState;
  const previousLiveAndAutoRefresh = usePrevious(liveAndAutoRefresh);
  const previousMetricFilter = usePrevious(metricFilter);
  return {
    isLiveMode: realTimeOnTrends,
    keepPreviousData: liveAndAutoRefresh,
    enableLoading: realTimeOnTrends && !syncedAutoRefreshState,
    reset: (previousLiveAndAutoRefresh !== liveAndAutoRefresh && liveAndAutoRefresh) || (!isEqual(previousMetricFilter, metricFilter) && enableSSF),
  }
}
